<template>
  <div class="login__wrap">
    <div class="login__content">
      <h1>
        <a @click.stop href="/"
          ><Logo class="logo" /><span class="sr-only">Motion Mail</span></a
        >
      </h1>
      <router-view :key="$route.fullPath"></router-view>
      <footer class="login__footer">
        <p class="layout--margin-top-xl layout--margin-bottom-xs">
          <a @click.stop href="/privacy" class="link">Privacy Policy</a>
          and
          <a @click.stop href="/terms" class="link">Terms of Use</a>
        </p>
        <p>
          MotionMail &#169; Copyright {{ new Date().getFullYear() }}. All rights
          reserved.
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Logo from "../assets/icons/motionmail-logo-2021.svg";

export default {
  name: "login",
  components: { Logo },
  // clear the user's session so they are now logged out and data cleared
  mounted() {
    // this.$modal.hideAll();
    if (this.loggedIn) {
      this.clearSession();
    }
  },
  computed: {
    ...mapGetters("session", ["error", "loggedIn"]),
  },
  methods: {
    ...mapActions("session", ["clearSession"]),
  },
};
</script>

<style lang="scss">
@import "../styles/pages/_login.scss";
</style>
